"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteCard = void 0;
var React = require("react");
var react_jss_1 = require("react-jss");
var FormattedDate_1 = require("./FormattedDate");
var AttributionTag_1 = require("./AttributionTag");
var useStyles = (0, react_jss_1.createUseStyles)({
    card: {
        fontFamily: "sans-serif",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "4px",
        flexDirection: "column",
        justifyContent: "center",
        padding: "1em",
        boxShadow: "0 1px 5px rgba(0,0,0,0.2)",
        transition: "all .25s ease-in-out",
        maxWidth: 632,
    },
    content: {
        fontSize: "larger",
    },
    date: {
        color: "rgb(0, 0, 0, 60%)",
    },
    attribution: {
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        "& a": {
            color: "black",
            textDecoration: "none",
        },
        "& a:hover": {
            textDecoration: "underline",
        },
        "& img": {
            marginRight: 5,
            width: 47,
            borderRadius: 5,
        },
    },
});
var NoteCard = function (_a) {
    var content = _a.content, published = _a.published, attributedTo = _a.attributedTo;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.card },
        React.createElement("div", { className: classes.attribution },
            React.createElement(AttributionTag_1.AttributionTag, { to: attributedTo })),
        React.createElement("p", { className: classes.content }, content),
        React.createElement(FormattedDate_1.FormattedDate, { className: classes.date, value: published })));
};
exports.NoteCard = NoteCard;
//# sourceMappingURL=NoteCard.js.map